import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "16",
  fill: "none",
  viewBox: "0 0 17 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#032E32",
      "fill-rule": "evenodd",
      d: "M8.5 0a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.766 4.095.5 5.555.5 7.318.5 9.366 2.208 11 4.281 11H8V5.5a.5.5 0 0 1 1 0V11h4.188c1.814 0 3.312-1.43 3.312-3.227 0-1.636-1.242-2.969-2.834-3.194C13.423 1.999 11.19 0 8.5 0ZM8.146 15.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L9 14.293V11H8v3.293l-2.146-2.147a.5.5 0 0 0-.708.708l3 3Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }